<template>
  <div class="wrap" v-loading="loading">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">差价单明细</div>
    </div>
    <div class="master" ref="master">
      <el-descriptions
        class="margin-top"
        title="单据信息"
        :column="2"
        size="medium"
      >
        <template slot="extra">
          <el-button
            v-if="status == 'A'"
            type="primary"
            size="mini"
            @click="confirm()"
            >确认</el-button
          >
          <el-button type="primary" size="mini" @click="print()"
            >打印</el-button
          >
        </template>
        <el-descriptions-item label="单号">{{
          master.ppd_code
        }}</el-descriptions-item>
        <el-descriptions-item label="日期">{{
          master.ppd_date
        }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{
          master.CreateBy
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          master.CreateOn
        }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{
          master.ApprovedBy
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          master.ApprovedOn
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{
          master.Status
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <template>
      <el-table
        :data="tableData"
        :style="contentStyleObj"
        fit
        border
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="item_code" label="货品编码"> </el-table-column>
        <el-table-column prop="item_name_cn" label="中文名称">
        </el-table-column>
        <el-table-column prop="codeForSupp" label="OEM"> </el-table-column>
        <el-table-column prop="carMod" label="车型"> </el-table-column>
        <el-table-column prop="wh_qty" label="库存数量"> </el-table-column>
        <el-table-column prop="item_qty" label="调价数量"> </el-table-column>
        <el-table-column prop="po_price" label="采购单价"> </el-table-column>
        <el-table-column prop="unit_price" label="现调整价"> </el-table-column>
        <el-table-column prop="difference" label="调控差价"> </el-table-column>
        <el-table-column prop="fund" label="调控金额"> </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
export default {
  name: "order_detail",
  props:['param'],
  data() {
    return {
      contentStyleObj: {
        height: "",
        "min-width": "1400px",
        overflow: "auto",
      },
      params: this.$route.params,
      tableData: [],
      status: "",
      master: [],
      loading: false,
      cell_style: {
        "text-align": "center",
      },
    };
  },
  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
  mounted(){
    this.getHeight();
  },
  methods: {
    async getData() {
      let params = JSON.parse(this.param);
      let res = await this.$Http.getDifferenceDetail(params);
      if (res.code == 0) {
        this.tableData = res.data.data;
        this.status = res.data.status;
        this.master = res.data.master;
      } else {
        this.$message.error(res.msg);
      }
    },
    //设置窗口高度
    getHeight() {
      this.contentStyleObj.height = window.innerHeight - 120 - 70 -15 - this.$refs.master.offsetHeight + "px";
    },
    /**
     * 确认
     */
    confirm() {
      this.$confirm("是否确认差价单？", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let params = JSON.parse(this.param);
          let res = await this.$Http.differenceConfirm(params);
          if (res.code == 0) {
            this.$message({
              message: "确认成功",
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    /**
     * 打印
     */
    print() {
      let params = JSON.parse(this.param);
      let url =
        this.GLOBAL.basic_url +
        "sr_scm/printDifference?dept_id=" +
        params.dept_id +
        "&ppd_code=" +
        params.ppd_code;
      window.open(url);
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // console.log(param);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        sums[index] = "";
        if (column.property == "fund") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(2);
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division {
  padding: 0 5px;
  color: #c0c4cc;
}
.btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
</style>